import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const addUser = async (module, { role, email, opts = {} }) => {
  const api = useApiStore();
  const { rootGetters, dispatch } = module;
  const user = { role, email };
  const config = Object.assign(getDefaultOpts(), opts);
  dispatch(
    "setSettingsVar",
    {
      key: "loading",
      value: true,
    },
    { root: true }
  );

  const { data } = await dispatch("httpRequest", {
    func: api.addUser(user),
    config,
  });

  await dispatch("httpRequest", {
    func: api.patchUserAccess(email),
    config,
  });

  const users = { ...rootGetters.getSettingsVar("users") };
  user.auth0ID = data.id;
  user.categories = ["*"]; // every new user starts with full-access
  users[data.id] = user;
  const newSelectedUserIndex = Object.values(users).length - 1;

  dispatch(
    "setSettingsVar",
    {
      key: "users",
      value: users,
    },
    { root: true }
  );
  // todo: remove this once the old settings page is removed
  dispatch(
    "setSettingsVar",
    {
      key: "selectedUserIndex",
      value: newSelectedUserIndex,
    },
    { root: true }
  );
  dispatch(
    "setSettingsVar",
    {
      key: "loading",
      value: false,
    },
    { root: true }
  );
};

export { addUser };
